import React from 'react';
import PropTypes from 'prop-types';
import GroupCohortsRow from './GroupCohortsRow';
import GroupCohortsHeader from './GroupCohortsHeader';
import TableFooter from '../../helpers/TableFooter';
import { isEmpty } from 'lodash';
import { tableNoResultsDefault, tableSpinnerDefault } from '../../helpers/TableHelpers';
import { isAdminDashboard } from 'utils/authScopes';
import { ASQ_RESULT_COLUMNS } from 'utils/asqResultColumns';

const COLUMNS_COUNT_BASE = 8;

const GroupCohortsTable = ({ ages, auth, data, meta, onPageChange, isLoading }) => {
  const rows = data.map(row => (
    <GroupCohortsRow key={`${row.groupId}-${row.subgroupId}-${row.cohortId}`} data={row} meta={meta} auth={auth} />
  ));
  // Keep in step with GroupCohortsHeader: the spinner and no-results rows span
  // this many columns.
  let columnsCount = COLUMNS_COUNT_BASE;
  if (isAdminDashboard(auth)) columnsCount++;
  if (meta.withcohorts) columnsCount += 2;
  if (meta.withages) columnsCount += ages.length;
  if (meta.withasq) columnsCount += ASQ_RESULT_COLUMNS.length;

  if (isLoading) {
    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='table-scroll'>
          <table className='o-table o-table--bordered'>
            <GroupCohortsHeader meta={meta} ages={ages} auth={auth} />
            <tbody>
              { tableSpinnerDefault(columnsCount) }
            </tbody>
          </table>
        </div>
        { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
      </div>
    )
  }

  if (!isLoading && isEmpty(data)) {
    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='table-scroll'>
          <table className='o-table o-table--bordered'>
            <GroupCohortsHeader meta={meta} ages={ages} auth={auth} />
            <tbody>
              { tableNoResultsDefault(columnsCount) }
            </tbody>
          </table>
        </div>
        { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
      </div>
    )
  }

  return (
    <div className='u-margin-bottom--gutter2x'>
      <div className='table-scroll'>
        <table className='o-table o-table--bordered'>
          <GroupCohortsHeader meta={meta} ages={ages} auth={auth} />
          <tbody>
            { rows }
          </tbody>
        </table>
      </div>
      { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
    </div>
  );
}

GroupCohortsTable.propTypes = {
  ages: PropTypes.arrayOf(PropTypes.object).isRequired,
  auth: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  meta: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPageChange: PropTypes.func.isRequired,
}

export default GroupCohortsTable;
